import { configureStore } from '@reduxjs/toolkit';

// Import slices as we create them
import appSlice from './slices/appSlice';

const store = configureStore({
  reducer: {
    // Add slices incrementally during migration
    app: appSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for non-serializable data
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Export types would go here if this was a TypeScript file
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

export default store;

// Re-export Redux utilities
export { useAppDispatch, useAppSelector, useReduxState } from './hooks';
export { useAppStateController } from './appStateController';
export * from './slices/appSlice'; 